import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, font } from '~styles/theme.stylex';
export const styles = {
  logo: {
    color: "x1xp53dl",
    $$css: true
  },
  grid: {
    display: "xrvj5dj",
    gridTemplateColumns: "x1tvfhds",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  tile: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    minWidth: "xeuugli",
    width: "xh8yej3",
    $$css: true
  },
  image: {
    width: "xh8yej3",
    aspectRatio: "x1plog1",
    borderRadius: "xaitoft",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    backgroundColor: "x4aap8p",
    color: "xarw3lm",
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    $$css: true
  },
  img: {
    width: "xh8yej3",
    height: "x5yr21d",
    objectFit: "xl1xv1r",
    $$css: true
  },
  fallback: {
    color: "xarw3lm",
    $$css: true
  },
  name: {
    maxWidth: "x193iq5w",
    fontSize: "x1dcheo9",
    fontWeight: "xr323w7",
    color: "xtt1gjl",
    textAlign: "x2b8uid",
    whiteSpace: "xuxw1ft",
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    textOverflow: "xlyipyv",
    $$css: true
  }
};